/* import __COLOCATED_TEMPLATE__ from './option-switch.hbs.js'; */
var _dec, _class;
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';

/*
  @param {String} heading - tooltip heading
  @param {String} description - tooltip description
  @param {String} label - option switch label
  @param {String} labelSecondary - option switch secondary label
  @param {String} vertical - The vertical that is using the tooltip.
                             It configures the brand color shown on the components/svgs/plus-badge-filled
                             Available verticals: ['restaurants', 'retail']
  @param {Action} onLearnMoreClick - action called when "Learn more" button is clicked
*/
let OptionSwitch = (_dec = classNames('upsell-option-switch__form'), _dec(_class = class OptionSwitch extends Component {}) || _class);
export { OptionSwitch as default };